import React, {createContext, FC, useEffect, useState} from "react";
import StepInfo from "pages/StepPages/components";
import {useAppDispatch, useAppSelector} from "toolkit/hooks";
import styles from "./SelectionCategories.module.sass";
import ReasonForNoCategory from "../ReasonForNoCategory/ReasonForNoCategory";
import {Button} from "components/shared";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {
  getCategorisingList,
  getReasons,
  setCategorisingList,
} from "toolkit/steps/stepFive/selectionCategories/selectionCategories.thunks";
import {clearCategorisingList, unFinish} from "toolkit/steps/stepFive/selectionCategories/selectionCategories.slice";
import {useOrganization} from "hooks/useOrganization";
import Wrapper from "pages/StepPages/StepFive/SelectionCategories/Wrapper";
import {AssignedCategoryInfo} from "libs/apiClient/data-contracts";
import {BUTTON_VARIANTS} from "../../../../components/shared/Button/Button";
import {ModalCreateTemplate} from "./ModalCreateTemplate";

export const SixFiveContext = createContext<any>({});

const SelectionCategories: FC = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const {organizationId,objId} = useParams();

  const state: any = useLocation().state;

  const selectedOrganization = useOrganization(Number(organizationId));

  const [selectedReason, setSelectedReason] = useState<{
    mode: 'reason' | 'radioCat'|null,
    reason: { id: number, name: string }|null
  }>({mode:null,reason:null});

  const [candidate, setCandidate] = useState<any>();

  const [disabled, setDisabled] = useState<any>(true);

  const [indexes, setIndexes] = useState({
    rowId: 0,
    sectionIndex: 0,
    mIndex: 0,
    bIndex: 0,
  });

  const [isVisibleModal, setIsVisibleModal] = useState<'radioCat' | 'reason' | null>(null);

  const [patternModal, setPatternModal] = useState<{
    active: boolean;
    data: number | null;
    mode: "create" | "select";
  }>({
    active: false,
    mode: "select",
    data: null,
  });

  const closePatternModal = () => setPatternModal((prevState) => ({ ...prevState, active: false, data: null }));

  const {categorisingList, loading} = useAppSelector((state) => state.selectionCategories);

  const [categorizatedData, setCategorizatedData] = useState<any>([]);

  const [r, setR] = useState<any[]>([]);

  const [f,setF] = useState<{func: ((reason:{id: number, name: string})=>void)|null}>({func:null})

  useEffect(() => {
    dispatch(getReasons());
    dispatch(unFinish());
    if (objId) {
      dispatch(getCategorisingList(+objId));
    }

    return () => {
      // readyData = [];
      dispatch(clearCategorisingList());
    };
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    setCategorizatedData(JSON.parse(JSON.stringify(categorisingList)));
    if (r.length) {
      setR([]);
    }

    if (categorisingList.length) {
      for (const category of categorisingList) {
        for (const itemOfM of category.listOfM) {
          for (const itemOfB of itemOfM.listOfB) {
            const newR = {
              applicabilityCat:itemOfB.applicabilityCat,
              stringId: itemOfB.stringId,
              firstCatSelectionStatus: itemOfB.firstCatSelectionStatus,
              customCat: itemOfB.customCat,
              firstCatTextValue: itemOfB.firstCatTextValue,
              indicatorTextValue: itemOfB.indicatorTextValue,
              secondCatTextValue: itemOfB.secondCatTextValue,
              thirdCatTextValue: itemOfB.thirdCatTextValue,
              organizationObject: {
                id: 1,
                name: "string",
              },
              result: "string",
              secondCatSelectionStatus: itemOfB.secondCatSelectionStatus,
              significanceCriteria: {
                id: itemOfB.stringId,
                name: "string",
              },
              thirdCatSelectionStatus: itemOfB.thirdCatSelectionStatus,
            };
            setR((prevState) => [...prevState, newR]);
          }
        }
      }
    }
    //eslint-disable-next-line
  }, [categorisingList]);
  const own = (row: any, sectionIndex: number, mIndex: number, bIndex: number) => {
    const candidate = categorizatedData
      .find((_: any) => _.stringId === sectionIndex)
      ?.listOfM.find((_: any) => _.stringId === mIndex)
      .listOfB.find((_: any) => _.stringId === bIndex);

    if (candidate) {
      setIndexes({rowId: row.stringId, sectionIndex, mIndex, bIndex});
      setCandidate(candidate);
    }
  };

  useEffect(() => {
    if (candidate) {
      if (selectedReason.mode === 'reason') {
        candidate.customCat = selectedReason.reason;
        if (candidate.customCat && selectedReason.reason) {
          candidate.applicabilityCat = null;
          setR((prevState) =>
            prevState.map((_) => (_.stringId === candidate.stringId ? {..._, customCat: selectedReason.reason} : _)),
          );
          // if (candidate.customCat.id === selectedReason.id) {
          // 	return;
          // } else {
          // 	candidate.customCat = selectedReason;
          // }
        }
      }

      for (const [key, value] of Object.entries(candidate)) {
        if (value === true) {
          candidate[key] = false;
        } else {
          candidate[key] = value;
        }
      }

      setCategorizatedData((prevState: any) => {
        const pState: any = [...prevState].map((_) => {
          if (_.stringId === indexes.sectionIndex) {
            return {
              ..._,
              listOfM: _.listOfM.map((M: any) => {
                if (M.stringId === indexes.mIndex) {
                  return {
                    ...M,
                    listOfB: M.listOfB.map((B: any) => {
                      if (B.stringId === candidate.stringId) {
                        return candidate;
                      } else {
                        return B;
                      }
                    }),
                  };
                } else {
                  return M;
                }
              }),
            };
          } else {
            return _;
          }
        });
        return pState;
      });
      setR((prevState) => prevState.map((_) => (_.stringId === candidate.stringId ? candidate : _)));
    }
    console.log(candidate)
    //eslint-disable-next-line
  }, [selectedReason]);

  const handleShowModal = () => {
    setIsVisibleModal('reason')
  };

  const handleCloseModal = () => setIsVisibleModal(null);

  const wrapperHandleCategorizatedData = (saveData:{value: string, sectionIndex: number, mIndex: number, bIndex: number}) => {
    setIsVisibleModal('radioCat');
    const {value,sectionIndex,mIndex,bIndex} = saveData
    let res = categorisingList
      .find((_) => _.stringId === sectionIndex)
      ?.listOfM.find((_: any) => _.stringId === mIndex)
      .listOfB.find((_: any) => _.stringId === bIndex);
    setCandidate(res);
    const updateApplicability = (reason:{id:number,name:string}) => {
      console.log(reason)
      handleCategorizatedData(value, sectionIndex, mIndex, bIndex, reason)
    }
    setF({func:updateApplicability});

  };

  const handleCategorizatedData = (value: string, sectionIndex: number, mIndex: number, bIndex: number,reason:{id:number,name:string}) => {
    console.log('super')
    let res = categorisingList
      .find((_) => _.stringId === sectionIndex)
      ?.listOfM.find((_: any) => _.stringId === mIndex)
      .listOfB.find((_: any) => _.stringId === bIndex);

    console.log('<<<res>>>', res);

    if (res) {
      let newData: any = {...res};
      for (const [key, value] of Object.entries(newData)) {
        if (value === true) {
          newData[key] = false;
        } else {
          if (key === "customCat") {
            newData[key] = null;
          }
          newData[key] = value;
        }
      }
      newData.customCat = null;
      newData.applicabilityCat = reason
      newData[value] = true;
      setCategorizatedData((prevState: any) => {
        const pState: any = [...prevState].map((_) => {
          if (_.stringId === sectionIndex) {
            return {
              ..._,
              listOfM: _.listOfM.map((M: any) => {
                if (M.stringId === mIndex) {
                  return {
                    ...M,
                    listOfB: M.listOfB.map((B: any) => {
                      if (B.stringId === bIndex) {
                        return newData;
                      } else {
                        return B;
                      }
                    }),
                  };
                } else {
                  return M;
                }
              }),
            };
          } else {
            return _;
          }
        });

        return pState;
      });
      setCandidate(newData)
      setR((prevState) => prevState.map((_) => (_.stringId === newData.stringId ? newData : _)));
    }
  };

  const handleSave = async () => {
    const newList = r.map((item) => {
      const {
        stringId: id,
        applicabilityCat,
        firstCatSelectionStatus: firstCatStatus,
        secondCatSelectionStatus: secondCatStatus,
        thirdCatSelectionStatus: thirdCatStatus,
        firstCatTextValue,
        indicatorTextValue,
        secondCatTextValue,
        thirdCatTextValue,
        thisItemParentItemIndex,
        customCat: inapplicabilityReason,

        ...rest
      } = item;

      return {
        ...rest,
        id,
        applicabilityReason:applicabilityCat,
        inapplicabilityReason,
        firstCatStatus,
        secondCatStatus,
        organizationObject: {
          id: 0,
          name: "string",
        },
        significanceCriteria: {
          id,
          name: "string",
        },
        thirdCatStatus,
        result: "string",
      };
    });
    dispatch(
      setCategorisingList({
        objId,
        newList,
      }),
    ).then((actions) => {
      const payload = actions.payload as AssignedCategoryInfo;

      navigate(`/categorization/finish/${organizationId}/${objId}`, {
        state: {
          objectName: payload.objectInfo.objectName,
          category: payload.category,
          actId: payload.objectInfo.topLevelKiiObjActDocId,
          resId: payload.objectInfo.topLevelKiiObjResultDocId,
        },
        replace: true,
      });
    });
  };

  const checkRows = () => {
    const result = r.map((item) => {
      return !!(
        item.firstCatSelectionStatus ||
        item.secondCatSelectionStatus ||
        item.thirdCatSelectionStatus ||
        item.customCat
      );
    });
    setDisabled(!result.every((item) => item));
  };
  useEffect(() => {
    checkRows();
    //eslint-disable-next-line
  }, [r]);

  return (
    <div className={styles["page-wrp"]}>
      <div className={styles.page}>
        <div className={styles.header}>
          <StepInfo
            stepTitle="5. Выбор категории значимости"
            info="Подбор категории"
            companyName={selectedOrganization?.fullName}
          />

          <div className={styles.objName}>{state.objectName}</div>
          {!state?.isTemplate?
              <Button disabled={disabled} onClick={handleSave} loading={loading}>
                  Сохранить и завершить
              </Button>
            :
            <Button disabled={disabled} onClick={()=>setPatternModal({ active: true, data: Number(objId), mode: "create" })} variant={BUTTON_VARIANTS.OUTLINED} loading={loading}>
              Сохранить шаблон
            </Button>

          }
        </div>

        <div className={styles.table}>
          <div className={styles.thead}>
            <div className={styles.tr}>
              <div>№</div>
              <div>Показатель</div>
              <div>3 категория</div>
              <div>2 категория</div>
              <div>1 категория</div>
              <div>Категория значимости не присваивается</div>
            </div>
          </div>
          <div className={styles.tbody}>
            <SixFiveContext.Provider value={{
              handleCategorizatedData:wrapperHandleCategorizatedData,
              handleShowModal,
              isTemplate:state?.isTemplate,
              own,
              data: categorizatedData
            }}>
              <Wrapper categorizatedData={categorizatedData}/>
            </SixFiveContext.Provider>
          </div>
          <ModalCreateTemplate target={patternModal} close={closePatternModal} />
          {isVisibleModal && candidate && (
            <ReasonForNoCategory
              mode={isVisibleModal}
              handleModalClose={handleCloseModal}
              setSelectedReason={isVisibleModal === 'reason' ? setSelectedReason : (reason: {
                id: number,
                name: string
              }) => f.func?.(reason)}
              candidate={candidate}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default SelectionCategories;
